<template>
  <el-dialog :visible="visible" :title="current.title || '平台公告'" width="min(600px, calc(100vw - 32px))" top="8vh" append-to-body :close-on-click-modal="false" @update:visible="visible = false" custom-class="home-announcement">
    <article :key="index" ref="reader" class="home-announcement-content">
      <template v-for="(block, i) in blocks"><img v-if="block.type === 'image' && image(block.url)" :key="i" :src="image(block.url)" alt="公告配图" @error="hideImage"><p v-else-if="block.type === 'text'" :key="i">{{ block.text }}</p></template>
    </article>
    <div slot="footer" class="home-announcement-actions">
      <div v-if="rows.length > 1" class="home-announcement-pages"><el-button size="small" :disabled="index === 0" @click="change(-1)">上一条</el-button><span>{{ index + 1 }} / {{ rows.length }}</span><el-button size="small" :disabled="index === rows.length - 1" @click="change(1)">下一条</el-button></div>
      <el-button type="primary" @click="visible = false">{{ current.btn_name || '我知道了' }}</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { apiHomePopups } from '@/utils/requestapis'
import { systemConfig } from '@/utils/systemConfig'
import { BASEURL } from '@/utils/realmName'
import { getToken } from '@/utils/cache'
import { newsContentBlocks, newsImageUrl } from '@/views/consult/newsContent'
import { shouldShowAnnouncement, markAnnouncementShown } from '@/utils/homeAnnouncement'
export default {
  data: () => ({ config: systemConfig, rows: [], index: 0, visible: false, sequence: 0 }),
  computed: {
    multiple() { return Number((this.config.data.app || {}).popup_switch) === 1 },
    sourceKey() { return this.config.ready ? BASEURL() + '|' + getToken() + '|' + this.multiple : '' },
    current() { return this.rows[this.index] || {} },
    blocks() { return newsContentBlocks(this.current.content) }
  },
  watch: { sourceKey: { immediate: true, handler() { this.load() } } },
  beforeDestroy() { this.sequence++ },
  methods: {
    async load() {
      const sequence = ++this.sequence; this.visible = false; this.rows = []; this.index = 0
      const sourceKey = this.sourceKey, multiple = this.multiple
      if (!sourceKey || !shouldShowAnnouncement()) return
      try {
        const result = await apiHomePopups(multiple)
        if (sequence !== this.sequence || sourceKey !== this.sourceKey) return
        const rows = multiple ? result : result && result.content ? [result] : []
        this.rows = Array.isArray(rows) ? rows.filter(item => item && typeof item.content === 'string' && item.content.trim()) : []
        this.visible = this.rows.length > 0 && shouldShowAnnouncement()
        if (this.visible) markAnnouncementShown()
      } catch (_) { /* Optional homepage content must not block the market page. */ }
    },
    change(step) { this.index = Math.max(0, Math.min(this.rows.length - 1, this.index + step)); if (this.$refs.reader) this.$refs.reader.scrollTop = 0 },
    image(value) { return newsImageUrl(value, BASEURL()) },
    hideImage(event) { event.target.style.display = 'none' }
  }
}
</script>
<style>
.home-announcement { border-radius:8px; background:var(--theme-panel); color:var(--theme-text); }
.home-announcement .el-dialog__header { padding-right:44px; }
.home-announcement .el-dialog__title { display:block; line-height:1.5; overflow-wrap:anywhere; color:var(--theme-text); }
.home-announcement .el-dialog__body { padding:0 20px; max-height:none; overflow:visible; }
.home-announcement-content { max-height:55vh; overflow-y:auto; overflow-wrap:anywhere; scrollbar-width:thin; color:var(--theme-label); }
.home-announcement-content p { margin:12px 0; white-space:pre-wrap; line-height:1.8; }
.home-announcement-content img { display:block; max-width:100%; height:auto; margin:12px auto; }
.home-announcement-actions,.home-announcement-pages { display:flex; align-items:center; justify-content:space-between; gap:12px; flex-wrap:wrap; }
.home-announcement-actions { justify-content:flex-end; }
.home-announcement-pages { margin-right:auto; color:var(--theme-muted); font-size:13px; }
.home-announcement-pages .el-button { margin:0; color:var(--theme-text); background:var(--theme-input); border-color:var(--theme-border); }
.home-announcement-pages .el-button.is-disabled { color:var(--theme-muted); opacity:.55; }
.home-announcement-actions > .el-button--primary { color:var(--theme-on-accent); background:var(--theme-accent); border-color:var(--theme-accent); }
</style>
